module.exports = __webpack_public_path__ + "static/Marchex-58c5585094589edef11b7acf6a526803.png";